import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { getInternalTrainingByUserIdQuery } from "./queries";
import { useUserContext } from "api/user/UserProvider";
import { fixUTF8InObject } from "utils/encodingHelper";

const InternalTrainingContext = createContext({});

export const useInternalTrainingContext = () =>
  useContext(InternalTrainingContext);

export const InternalTrainingProvider = ({ ...props }) => {
  const [internalTraining, setInternalTraining] = useState([]);
  const { userScope } = useUserContext();

  const getInternalTrainingByUserId = useCallback(
    async ({ id }) => {
      try {
        const result = await getInternalTrainingByUserIdQuery({
          id,
          userScope,
        });
        const fixedResult = fixUTF8InObject(result);
        setInternalTraining(fixedResult);
      } catch (e) {
        console.error("getInternalTrainingByUserId", e);
        throw e;
      }
    },
    [userScope]
  );

  const values = useMemo(
    () => ({
      internalTraining,
      setInternalTraining,
      getInternalTrainingByUserId,
    }),
    [internalTraining, setInternalTraining, getInternalTrainingByUserId]
  );

  return <InternalTrainingContext.Provider value={values} {...props} />;
};
